import { FileTypeEnum as e } from "../libs/types/dist/index6.mjs";
const a = {
  [e.Image]: "file_manager.file_type.image",
  [e.ImageOther]: "file_manager.file_type.image_other",
  [e.Video]: "file_manager.file_type.video",
  [e.Audio]: "file_manager.file_type.audio",
  [e.Font]: "file_manager.file_type.font",
  [e.Document]: "file_manager.file_type.document"
};
export {
  e as FileTypeEnum,
  a as FileTypeEnumLocoKeys
};
